import Image from "next/image";
import React from "react";

const NextButton = ({ handleNext, isNextDisabled }) => {
  return (
    <button
      onClick={handleNext}
      disabled={isNextDisabled}
      className="absolute right-4 bottom-2.5 bg-black bg-opacity-40 flex items-center justify-center w-8 h-8 disabled:opacity-50 rounded-full backdrop-invert-custom"
    >
      <Image src="/icons/next.svg" width={12} height={12} alt="right-arrow" />
    </button>
  );
};

export default NextButton;
